import Catalog from './components/Catalog';
import Element from './components/Element';

export const catalog = {
  firstLevel:  Catalog,
  secondLevel: Catalog,
  thirdLevel:  Element,
};